import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import colors from '../../scss/variables.module.scss';

/* inward user sub menu data */
const inwardUserSubMenu = [
  { name: 'Raw Material (Paddy)', path: '/shipment/inward/rawMaterial/create' },
  { name: 'Bags', path: '/shipment/inward/bags/paddy' },
  { name: 'Other Items', path: '/shipment/inward/otherItems' },
];

/* React functional component */
const InwardUserTabLayout = () => {
  /* extracting location from useLocation hook */
  const location = useLocation();

  return (
    <div className="subMenu">
      <Menu
        style={{ backgroundColor: colors.colorBlack, display: 'flex' }}
        selectedKeys={[location.pathname]}
      >
        {inwardUserSubMenu.map((item) => {
          return (
            <Menu.Item key={item.path}>
              <Link to={item.path} style={{ fontWeight: '500', fontSize: 14 }}>
                {item.name}
              </Link>
            </Menu.Item>
          );
        })}
      </Menu>
      <Outlet />
    </div>
  );
};

export default InwardUserTabLayout;
